import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { NbIconConfig } from '@nebular/theme';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { AveriasService } from '../servicios/averias.service';
import { SelectItem } from 'primeng/api';
import { Tipo } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

@Component({
    selector: 'app-tipo',
    templateUrl: './tipo.component.html',
    styleUrls: ['./tipo.component.css'],
    styles: [`
    :host nb-tab {
      padding: 1.25rem;
    }
  `],
  standalone: true,
  imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule, SpinnerComponent,
    MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule,
  AgGridAngular, NbCheckboxModule],
  providers: [DatePipe],

})
export class TipoComponent implements OnInit {
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  checked = false;
  tipoOK = false;
  tipo: SelectItem[];
  showTipo = false;
  IdTipo: number;
  tipoProcesado;
  descripcionTipo;
  descripcionBreve;
  clienteId;
  codigoExterno;
  grupo;
  grupoProcesado;
  grupoProcesadoAlta;
  grupoTipo: SelectItem[];
  averiasOK = false;
  IdGrupoTipo: number;
  tipoCompleto;
  grupoTipoCompleto;
  descripcionBreveEditar;
  descripcionTipoEditar;
  codigoExternoEditar;
  datasetTipo: any[] = [];
  datasetTipoModificar: any[] = [];
  datasetTipoConsulta: any[] = [];
  angularGridTipo: AngularGridInstance;
  angularGridTipoModificar: AngularGridInstance;
  angularGridTipoConsulta: AngularGridInstance;
  dataViewTipo: any;
  columnDefinitionsTipo: ColDef[];//Column[];
  columnDefinitionsTipoModificar: ColDef[];//Column[];
  gridOptionsTipo: GridOption;
  gridOptionsTipoModificar: GridOption;
  gridOptionsTipoConsulta: GridOption;
  gridObjTipo: any;
  showGrillaTipo = false;
  showSpinner = false;
  showSpinnerModificarGrilla = false;
  showGrillaTipoModificar = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  showTipoModificar = false;

  columnDefinitionsTipoConsulta: ColDef[]; //Column[];
  gridOptionsAreaConsulta: GridOption;
  showSpinnerConsulta = false;
  showTipoConsulta = false;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit() {
    this.idCliente = Number( localStorage.getItem("idCliente"));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.consultarGrupoTipo();
    this.svcAnalytics.setAnalyticsPageView();
  }

  ngAfterViewInit():void {
  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarTipo();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarTipoConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarTipoModificar();
    }
  }

  bellIconConfig: NbIconConfig = { icon: 'bell-outline', pack: 'eva' };

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarTipo() {
    this.showSpinner = true;
    this.showGrillaTipo = false
    this.AveriasService.getTipo(this.idCliente).subscribe(
      data => {
        this.tipoCompleto = data;
        this.tipo = this.insertarTipo(data);
        this.traerDatosTipo();
        this.fillGrillaTipo();
      });
  }
  consultarTipoConsulta() {
    this.showSpinnerConsulta = true;
    this.showTipoConsulta = false
    this.AveriasService.getTipo(this.idCliente).subscribe(
      data => {
        this.tipoCompleto = data;
        this.traerDatosTipoConsulta();
        this.fillGrillaTipoConsulta();
      });
  }
  consultarTipoModificar() {
    this.showSpinnerModificarGrilla = true;
    this.showTipoModificar = false;
    this.AveriasService.getTipo(this.idCliente).subscribe(
      data => {
        this.tipoCompleto = data;
        this.tipo = this.insertarTipo(data);
        this.traerDatosTipoModificar();
        this.fillGrillaTipoModificar();
      });
  }
  insertarTipo(armarTipo) {
    let averiasTipo: Array<any> = [];
    armarTipo.content.forEach(element => {
      averiasTipo.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasTipo;
  };
  capturarTipo(event) {
    this.IdTipo = event;
    this.tipoOK = true;
  }
  consultarGrupoTipo() {
    this.AveriasService.getGrupoTipo(this.idCliente).subscribe(
      data => {
        this.grupoTipo = this.insertarGrupoTipo(data);
        this.grupoTipoCompleto = data;
      });
  }
  insertarGrupoTipo(armarGrupoTipo) {
    let averiasGrupoTipo: Array<any> = [];
    armarGrupoTipo.content.forEach(element => {
      averiasGrupoTipo.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasGrupoTipo;
  };
  capturarGrupoTipo(event) {
    this.IdGrupoTipo = event;
    this.averiasOK = true;
  }
  altaTipo() {
    let tipo: Tipo;

    if (this.descripcionTipo == null || this.descripcionTipo == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else {
      tipo = {
        descripcion: this.descripcionTipo,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idGrupoAveria: this.grupoProcesadoAlta,
        idCliente: this.idCliente,
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postTipo(tipo).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.openSnackBar("Los cambios se han guardado correctamente");
        this.descripcionTipo = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.grupoProcesado = '';
        this.tipoProcesado = '';
        this.consultarTipo();
        this.consultarGrupoTipo();
        this.showSpinnerGuardar = false;
      })
      
    }
  }
  modificarTipo () {
    let tipo: Tipo ; 
    if (this.eliminar) {
      this.AveriasService.deleteTipo(this.tipoProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionTipoEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.tipoProcesado = '';
          this.grupoProcesado = '';
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminar = false;
        this.eliminarSeleccionado = false;
        this.consultarTipoModificar();
      })
    } else {
      if (this.descripcionTipoEditar == null || this.descripcionTipoEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        tipo = {
          descripcion: this.descripcionTipoEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idGrupoAveria: this.grupoProcesado,
          idCliente: this.idCliente,
      }
      this.AveriasService.putTipo(this.tipoProcesado, tipo).subscribe(data =>{
        this.showSpinnerModificar = false;
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
          this.eliminar = false;
          this.eliminarSeleccionado = false;
        }
        else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.eliminar = false;
        this.eliminarSeleccionado = false;
        this.consultarTipoModificar();
      })
      this.descripcionTipoEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.tipoProcesado = '';
      this.grupoProcesado = '';
      this.eliminarSeleccionado = false;
      
    }
    }
  }
  obtenerDescripcionDropdown(IdTipo: number) {
    let resp = this.tipoCompleto.content.find(n => n['id'] == IdTipo);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionTipoEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
    this.grupoProcesado = resp['idGrupoTipoAveria']
  }
  traerDatosTipo() {
    let DatosTipo = this.tipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosTipo.length; i++) {
    mockDataset.push({
      id: DatosTipo[i]["id"],
      Descripcion: DatosTipo[i]["descripcion"],
      Codigo: DatosTipo[i]["codigoExterno"],
      Grupo: DatosTipo[i]["idGrupoTipoAveria"],
    });
  }
    this.datasetTipo  = mockDataset;
    this.showSpinner = false;
    this.showGrillaTipo = true;
  }
  traerDatosTipoConsulta() {
    let DatosTipo = this.tipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosTipo.length; i++) {
    mockDataset.push({
      id: DatosTipo[i]["id"],
      Descripcion: DatosTipo[i]["descripcion"],
      Codigo: DatosTipo[i]["codigoExterno"],
      Grupo: DatosTipo[i]["idGrupoTipoAveria"],
    });
  }
    this.datasetTipoConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showTipoConsulta = true;
  }

  traerDatosTipoModificar() {
    let DatosTipo = this.tipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosTipo.length; i++) {
    mockDataset.push({
      id: DatosTipo[i]["id"],
      Descripcion: DatosTipo[i]["descripcion"],
      Codigo: DatosTipo[i]["codigoExterno"],
      Grupo: DatosTipo[i]["idGrupoTipoAveria"],
    });
  }
    this.datasetTipoModificar  = mockDataset;
    this.showSpinnerModificarGrilla = false;
    this.showTipoModificar = true;
  }

  fillGrillaTipo() {
    this.columnDefinitionsTipo = [
      { //id: 'Descripcion',
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo',
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
      { //id: 'Grupo',
        headerName: 'Grupo', field: 'Grupo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsTipo = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaTipoConsulta() {
    this.columnDefinitionsTipoConsulta = [
      { //id: 'Descripcion',
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo',
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
      { //id: 'Grupo',
        headerName: 'Grupo', field: 'Grupo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsTipoConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaTipoModificar() {
    this.columnDefinitionsTipoModificar = [
      { //id: 'Descripcion',
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo',
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
      { //id: 'Grupo',
        headerName: 'Grupo', field: 'Grupo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsTipoModificar = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  angularGridReadyTipo(angularGrid: AngularGridInstance){
    this.angularGridTipo = angularGrid;
    this.angularGridTipo.resizerService.pauseResizer(false)
  }
  angularGridReadyTipoConsulta(angularGrid: AngularGridInstance){
    this.angularGridTipoConsulta = angularGrid;
    this.angularGridTipoConsulta.resizerService.pauseResizer(false)
  }

  angularGridReadyTipoModificar(angularGrid: AngularGridInstance){
    this.angularGridTipoModificar = angularGrid;
    this.angularGridTipoModificar.resizerService.pauseResizer(false)
  }

  exportToExcelTipo() {
    (this.angularGridTipoConsulta as any).excelExportService.exportToExcel({
      filename: 'Tipo_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
      format: FileType.xlsx
    });
  }

    onGridReady(params: GridReadyEvent): void {
   // this.gridApi = params.api;
 //   this.gridColumnApi = params.columnApi;
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }

}
